import React, { useCallback,useState, useEffect } from "react";
import { connect } from "react-redux";
import FileSaver from "file-saver";
import { bindActionCreators } from "redux";
import Chart from 'react-apexcharts'
import { useCurrentPng } from "recharts-to-png";
import Reports from "../../ducks/Reports";
import Things from "../../ducks/Things";
import Visualization from "../../ducks/Visualization";
import * as _ from "lodash";
import { validateInput } from "../../validations/violationBar";
import { WhiteSpinner } from "../common/Spinner/index";
import {
  PieChart,Sector,Pie,
  ResponsiveContainer,
} from "recharts";
import DateTime from "react-datetime";
import {
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import moment from "moment";

const SummaryChart = (props) => {
  const [activeTab, setActiveTab] = useState("devices");
  const [state, setState] = useState({
    selectedDevices: [],
    activeIndex: 0,
    errors: {},
    loader: false,
    violations: [],
    selectedViolations: [],
    startDate: moment().subtract("1", "days"),
    endDate: moment(),
    data: [],
    series: [ 5,55, 20, 65, 60],
    options: {
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: ['Violation Devices','Normal Devices'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  });
  const [modal, setModal] = useState(false);
  const [getSummaryPng, { ref: summaryRef }] = useCurrentPng();
  const [modalData, setModalData] = useState([]);
  const [eventName, setEventName] = useState('');


  const handleSummaryDownload = useCallback(async () => {
    const png = await getSummaryPng();
    if (png) {
      FileSaver.saveAs(png, "summary-chart.png");
    }
  }, [getSummaryPng]);

  const onChangeStartDate = (e) => {
    setState({ ...state, startDate: new Date(e) });
  };
  const onChangeEndDate = (e) => {
    setState({ ...state, endDate: new Date(e) });
  };
  const isValid = () => {
    const { errors, isValid } = validateInput(state);
    if (!isValid) {
      setState({ ...state, errors });
    }
    return isValid;
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (state.loader) {
      return;
    }
      delete state.errors;
      setState({
        ...state,
        loader: true,
      });
      const requestObject = {
        startDate: state.startDate.toISOString(),
        endDate: state.endDate.toISOString(),
      };
      //call api
      await props.chartActions.loadSummaryChartData(requestObject);
      setState({
        ...state,
        loader: false,
      });
  };
  // const download = async () => {
  //   if (state.loader) {
  //     return;
  //   }
  //   if (isValid()) {
  //     delete state.errors;
  //     setState({
  //       ...state,
  //     });
  //     const requestObject = {
  //       devices: state.selectedDevices,
  //       eventType: state.selectedViolations.map((sv) => sv.value),
  //       interval: {
  //         startDate: state.startDate.toISOString(),
  //         endDate: state.endDate.toISOString(),
  //       },
  //       reportType: "violationVisualReport",
  //     };
  //     await props.reportActions.exportReport(requestObject);
  //   }
  // };

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value} %`}</text>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
          {`(Rate ${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };

  const onPieEnter = (_, index) => {
    setState({
      ...state,
      activeIndex: index,
    });
  };
  const showModal = (event, eventName) => {
    setModalData(props.violation.count[event].events || [])
    setModal(true);
    setEventName(eventName);
  };

  const renderCustomizedLabel = ({
    x, y, name
  }) => {
    return (
      <text x={x} y={y} fill="black" textAnchor="end" dominantBaseline="central">
        {name}
      </text>
    );
  };
  const toggle = () => setModal(!modal);
  const loader = <WhiteSpinner key="1" />;
  console.log("---violation---",props.violation)
  return (
    <>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{`${eventName} Violation Details`}</ModalHeader>
        <ModalBody>
          <table className='table-auxo'>
            <thead>
              <tr>
              <th>Plate Number</th>
              <th>Group</th>
              <th>Violation Time</th>
              <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {modalData.map((row, index) => {
                return (
                  <tr key={index.toString()}>
                    <td className="modal-cell">{row.thingId.plateNumber}</td>
                    <td className="modal-cell">{row.thingId.group.name}</td>
                    <td className="modal-cell">{moment(row.eventTime).format("DD-MMM-YYYY hh:mm a")}</td>
                    <td className="modal-cell"><a href={`https://google.com/maps/search/${row.thing.state.latlng}`} target="_blank" rel="noopener noreferrer">{row.location}</a></td>
                  </tr>
                )
              })}
              {
                modalData.length === 0 && <tr>
                  <td colSpan="4" style={{textAlign: "center"}}>
                    No Violations found.
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <button className="btn auxo-primary-btn create-geofence-btn" onClick={toggle}>Close</button>
        </ModalFooter>
      </Modal>
      <div className="row">
        <div className="col-md-4">
          <form onSubmit={onSubmit}>
            <Card className="height-100-p " style={{ minWidth: "100%" }}>
              <CardHeader className="f-bold">Filter Criteria</CardHeader>
              <div className="col p-10-px">
                <div className="form-group">
                </div>
                <div className="form-group">
                  <label>Start Date</label>
                  <DateTime
                    value={state.startDate}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={onChangeStartDate}
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.startDate}</span>
                )}
                <div className="form-group">
                  <label>End Date</label>
                  <DateTime
                    value={state.endDate}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={onChangeEndDate}
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.endDate}</span>
                )}
                <div className="tab-content access-tab mb-5 heading-200">
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.devices}</span>
                )}

                <div className="margin-btm-50">
                  <button
                    className="btn auxo-primary-btn create-geofence-btn"
                    type="submit"
                  >
                    {state.loader ? [loader] : "Filter"}
                  </button>
                </div>
              </div>
            </Card>
          </form>
        </div>
        <div className="col-md-8">
          <Card className="height-100-p" style={{ minWidth: "100%" }}>
            <CardHeader className="f-bold">
              Visualization
              {props.violation?.data && (
                <span>
                  <button
                    className="btn auxo-primary-btn m-btn-v"
                    type="button"
                    onClick={() => handleSummaryDownload()}
                  >
                    <i className="fa fa-download"></i>
                  </button>
                </span>
              )}
            </CardHeader>
            {props.violation?.data && (
              <div className="row" style={{ margin: "11px 0px 1px 0px" }}>
                <div className="col-md-2 offset-md-1 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation?.numOfDevices || 0}
                    </span>
                    <p className="f-11-px text-center">Number Of Devices</p>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation?.totalViolations || 0}
                    </span>
                    <p className="f-11-px text-center">Total Violations</p>
                  </div>
                </div>
              </div>
            )}

            {props.violation?.data && (
               <Chart options={state.options} series={props.violation.data} type="pie" width={500} height={320} />
              // <ResponsiveContainer width="100%" height="100%">
              //   <PieChart ref={summaryRef} width={500} height={400}>
              //     <Pie 
              //       data={props.violation.data?.violations} 
              //       dataKey="value" 
              //       nameKey="name" 
              //       cx="50%" 
              //       cy="50%" 
              //       innerRadius={60} 
              //       outerRadius={80} 
              //       fill="#82ca9d" 
              //       label
              //      />
              //   <Pie
              //     activeIndex={state.activeIndex}
              //     activeShape={renderActiveShape}
              //     data={props.violation.data?.violations}
              //     cx="50%"
              //     cy="50%"
              //     innerRadius={90}
              //     outerRadius={110}
              //     fill="#8884d8"
              //     dataKey="value"
              //     onMouseEnter={onPieEnter}
              //   />
              //   </PieChart>
              // </ResponsiveContainer>  
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  violation: state.visualization.violationChartSummary,
});
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Things.creators, dispatch),
  chartActions: bindActionCreators(Visualization.creators, dispatch),
  reportActions: bindActionCreators(Reports.creators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryChart);
